import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { RowCard } from '../patterns';
import type { UpcomingSession } from '../../services/sprayDashboardService';
import { formatDateShort } from '../../dateFormat';

const VISIBLE_LIMIT = 5;

export interface SprayUpcomingSessionsCardProps { sessions: UpcomingSession[] }

export const SprayUpcomingSessionsCard: React.FC<SprayUpcomingSessionsCardProps> = ({ sessions }) => {
  const { t } = useTranslation();
  if (sessions.length === 0) return null;

  const visible = sessions.slice(0, VISIBLE_LIMIT);

  return (
    <section className="spray-dashboard__list-card" data-testid="spray-upcoming-sessions-card">
      <header className="spray-dashboard__list-card-header">
        <h3 className="spray-dashboard__list-card-title">{t('spray.dashboard.upcomingSessions.title')}</h3>
        <Link to="/protection/sessions?filter=upcoming-30d" className="spray-dashboard__list-card-viewall">
          {t('spray.dashboard.upcomingSessions.viewAll')} →
        </Link>
      </header>
      <div className="spray-dashboard__list-card-body">
        {visible.map(s => (
          <RowCard
            key={s._id}
            icon="bi-droplet"
            title={t('spray.dashboard.upcomingSessions.row.title', { program: s.programName ?? '—', orchard: s.orchardName || '—' })}
            subtitle={t('spray.dashboard.upcomingSessions.row.subtitle', {
              date: s.startDate ? formatDateShort(s.startDate) : '—',
              machine: s.machineName ?? '—',
              operator: s.operatorName || '—',
            })}
          />
        ))}
      </div>
    </section>
  );
};

export default SprayUpcomingSessionsCard;
